import React from 'react';
import { aboutData, workspaceImage } from '../data/mock';
import { Award, Briefcase, Palette, Globe } from 'lucide-react';

const credentialIcons = {
  'NIFT Kolkata Alumna': Award,
  'Leather & Non-Leather Specialist': Palette,
  'End-to-End Product Development': Briefcase,
  'International Brand Collaboration': Globe,
};

const AboutSection = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-inter text-xs tracking-[0.3em] uppercase text-[#8B7355]">
            About
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-light text-[#3D3D3D] mt-4">
            The Designer
          </h2>
          <div className="w-12 h-[1px] bg-[#8B7355] mx-auto mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={workspaceImage}
                alt="Design workspace"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
            {/* Decorative Frame */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#8B7355]/30 -z-10" />
          </div>

          {/* Content */}
          <div className="lg:pl-8">
            <h3 className="font-playfair text-2xl md:text-3xl text-[#3D3D3D] mb-2">
              {aboutData.name}
            </h3>
            <p className="font-inter text-sm tracking-widest uppercase text-[#8B7355] mb-8">
              {aboutData.title}
            </p>

            <p className="font-inter text-base text-[#5A5A5A] leading-relaxed mb-6">
              {aboutData.bio}
            </p>

            <p className="font-inter text-base text-[#5A5A5A] leading-relaxed mb-10">
              {aboutData.extendedBio}
            </p>

            {/* Credentials */}
            <div className="grid grid-cols-2 gap-4">
              {aboutData.credentials.map((credential, index) => {
                const IconComponent = credentialIcons[credential] || Award;
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-3 bg-[#F5F1EC] hover:bg-[#EDE8E1] transition-colors duration-300"
                  >
                    <IconComponent
                      size={18}
                      className="text-[#8B7355] flex-shrink-0"
                      strokeWidth={1.5}
                    />
                    <span className="font-inter text-xs text-[#3D3D3D] leading-tight">
                      {credential}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
